module.exports = __webpack_public_path__ + "img/cover-3.38f5c86d.png";